<template>
  <div>
    <!-- 面包屑 -->
    <a-breadcrumb style="padding: 16px 24px 12px;text-align: left;">
      <a-breadcrumb-item><a-icon type="arrow-left" v-show="routeData.length>3"   @click="$router.go(-1)" style="margin-right:10px;cursor:pointer;" />首页</a-breadcrumb-item>
      <a-breadcrumb-item >{{routeData[1].meta.title}}</a-breadcrumb-item>

      <a-breadcrumb-item v-if="routeData.length == 3">{{routeData[2].meta.title}}</a-breadcrumb-item>
      <a-breadcrumb-item v-if="routeData.length > 3" ><span style="cursor: pointer;" @click="jumpTo3" >{{routeData[2].meta.title}}</span></a-breadcrumb-item>
      
      <a-breadcrumb-item v-if="routeData.length == 4&&routeData[3].meta.title">{{routeData[3].meta.title}}</a-breadcrumb-item>
      <a-breadcrumb-item v-else-if="routeData.length > 4&&routeData[3].meta.title"><span style="cursor: pointer;" @click="jumpTo4" >{{routeData[3].meta.title}}</span></a-breadcrumb-item>
      <a-breadcrumb-item v-if="routeData.length == 5&&routeData[4].meta.title">{{routeData[4].meta.title}}</a-breadcrumb-item>
      <a-breadcrumb-item v-if="routeData.length > 5&&routeData[4].meta.title"><span style="cursor: pointer;" @click="jumpTo5" >{{routeData[4].meta.title}}</span></a-breadcrumb-item>

      <a-breadcrumb-item v-if="routeData.length == 6&&routeData[5]">{{routeData[5].meta.title}}</a-breadcrumb-item>
      <a-breadcrumb-item v-if="title&&title!=''">
        <span>{{title}}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div style="padding:0 0 16px 24px;font-weight:500;font-size:18px;color:#000000">
      <span>{{title||routeData[routeData.length-1].meta.title}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:"breadcrumb",
  props:['routeData'],
  computed: {
    title(){
      return this.$route.query&&this.$route.query.title
    },
    message(){
      if (this.$route.name == 'message') {
        return 0
      }else{
        return localStorage.getItem("messageCount")
      }
    },
  },
  methods:{
    jumpTo3(){
      let name = this.routeData[2].name||'';
      this.$router.push({name})
    },
    jumpTo4(){
      let name = this.$route.name;
      if (name == "frozen-detail") {
        this.$router.go(-1)
        return
      }else if (name == "used-detail") {
        this.$router.go(-1)
        return
      }else if (name == "settlement-detail") {
        this.$router.go(-1)
        return
      }else if (name == "order-detail"||name == "order-channel"||name == "order-advance") {
        if (this.routeData.length == 6) {
          this.$router.go(-2)
          return
        }
        this.$router.go(-1)
        return
      }
    },
    jumpTo5(){
      let name = this.$route.name;
      if (name == "order-detail"||name == "order-after") {
        this.$router.go(-1)
        return
      }
    },
  }
};
</script>

